import React from 'react';
import styles from './ProductOffers.module.scss';
import { ReactComponent as DeliveryTimeIcon } from '../../images/icons/delivery-time.svg';
import { ReactComponent as DeliveryCostIcon } from '../../images/icons/delivery-costs.svg';
import Price from '../Price/Price';
import Rating from '../Rating/Rating';
import { FormattedMessage } from 'react-intl';
import getCDNImage from '../../utils/getCDNImage';
import Button from '../Button/Button';
import classNames from 'classnames';
import { ReactComponent as ExclamationMarkIcon } from '../../images/icons/exclamation_mark.svg';
import { Link } from 'react-router-dom';
import ProductOfferImgWrapper from '../ProductOfferImgWrapper';

const ExpiredOffer = ({
  ShopWrapper,
  shopLink,
  pdpLink,
  shopLogo,
  shopName,
  shopRating,
  deliveryTime,
  deliveryCosts,
  currency,
  price,
}) => {
  const shopLogoSrc = getCDNImage(shopLogo);
  return (
    <div className={classNames(styles.offer, styles.expiredOffer)}>
      <Link
        to={pdpLink}
        className={styles.shopLogo}
        link={shopLink}
        aria-label={`Go to ${shopName} product page`}
        title={`Go to ${shopName} product page`}
      >
        {/* Image dimensions: w=160, h=70 */}
        <ProductOfferImgWrapper src={shopLogoSrc} shopName={shopName}>
          <img src={shopLogoSrc} alt={`${shopName} logo`} />
        </ProductOfferImgWrapper>
      </Link>
      <ShopWrapper className={styles.shopInfo} link={shopLink}>
        <div className={styles.shopName}>{shopName}</div>
        <div className={styles.shopRating}>
          <Rating value={shopRating} />
        </div>
      </ShopWrapper>
      {/* <div className={styles.trustmark}>
        <img src={getCDNImage(shopLogo)} />
      </div> */}
      <div className={styles.delivery}>
        <div className={styles.deliveryTime}>
          <DeliveryTimeIcon /> {deliveryTime}
        </div>
        <div className={styles.deliveryPrice}>
          <DeliveryCostIcon />
          {deliveryCosts === 0 && <FormattedMessage id="product.freeDelivery" default="Free delivery" />}
          {deliveryCosts === null && <FormattedMessage id="common.unknown" default="Unknown" />}
          {deliveryCosts > 0 && <Price currency={currency} price={deliveryCosts} />}
        </div>
      </div>
      <div className={styles.price}>
        <Price currency={currency} price={price} />
      </div>
      <action className={styles.action}>
        <Button
          classList={{ icon: styles.expiredBtnIconWrapper }}
          variation="without-style"
          disabled
          iconPosition="left"
          icon={<ExclamationMarkIcon />}
        >
          <FormattedMessage id="shop.noLongerAvailable" defaultMessage="No longer available" />
        </Button>
      </action>
    </div>
  );
};

export default ExpiredOffer;
